export type EntityId = string | number | Date
